import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import { fetcher, endpoints } from 'src/utils/axios';
// types
import { IProductItem, facility } from 'src/types/product';




export function useGetFacility(page=1) {
    const URL = `${endpoints.facility.getfacility}?page=${page}`;
    
    const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

    const memoizedValue = useMemo(
      () => ({
        facilitydata: (data?.results as facility[]) || [],
        productsLoading: isLoading,
        total:(data?.total as number || 0),
        productsError: error,
        productsValidating: isValidating,
      }),
      [data?.results,  data?.total,error, isLoading, isValidating]
    );
  
    return memoizedValue;
  }